module.exports = "https://milano-network.servercdn.it/static/fonts/FuturaPT-Book.woff?c431096955795da262fc32297d7bfa8f";